/** Parse timestamps from API (RFC 2822, ISO, or SQL without timezone). */
export function parseServerDate(value) {
  if (value == null || value === '') return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const raw = String(value).trim();
  if (!raw) return null;

  // RFC 2822 / HTTP dates (e.g. "Tue, 01 Sep 2026 20:10:31 GMT")
  let date = new Date(raw);
  if (!Number.isNaN(date.getTime())) return date;

  // SQL-style UTC without suffix (e.g. "2026-09-01 20:10:31")
  const normalized = raw.includes('T') ? raw : raw.replace(' ', 'T');
  const hasTimezone = /([zZ]|[+\-]\d{2}:?\d{2}|GMT|UTC)$/i.test(normalized);
  date = new Date(hasTimezone ? normalized : `${normalized}Z`);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatLastSeen(value) {
  const date = parseServerDate(value);
  if (!date) return 'Unknown';

  return date.toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
}

export function formatLogTime(value) {
  const date = parseServerDate(value);
  if (!date) return value ? String(value) : '-';

  return date.toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
}
